import { Box } from '@material-ui/core';

const PhotoAlertBox = ({ className, children }) => (
  <Box className={`alert ${className}`}>{children}</Box>
);

export default PhotoAlertBox;
